import * as React from 'react';

import TextLeft16 from './TextLeft16';

export const textLeft16 = () => <TextLeft16 />;

export default {
    title: 'Icon/Line/TextLeft16',
    component: TextLeft16,
    parameters: {
        notes: "`import TextLeft16 from 'box-ui-elements/es/icon/line/TextLeft16';`",
    },
};
